import React from 'react';

import BASELoading from '../../../../../../../@BASE/core/BASELoading';
import BASESvgIcon from '../../../../../../../@BASE/core/BASESvgIcon';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Instructions from '../components/Instructions';

export default function FPEEnvironmentHome(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === 'rtl' ? 'text-18' : 'text-14'} ${
    course?.language?.acronym
  }`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <div
        className="w-full flex flex-col justify-center items-center"
        style={{ height: '360px' }}
      >
        <BASESvgIcon size={32}>heroicons-outline:exclamation</BASESvgIcon>
        <Typography variant="subtitle2" className="font-semibold mt-32">
          Content on this page is pending Alpha IMI Development.
        </Typography>
      </div>
    </div>
  );
}
